import Vue from 'vue'

const fileUpload = async (file, config) => {
  var formData = new FormData()
  formData.append('file', file)
  const res = await Vue.prototype.$http.post(config.url, formData, config)
  console.log('res', res)
  return res
}

export default {
  computed: {
    acceptStr () {
      if (this.accept) {
        return this.accept.join(', ')
      }
      return ''
    }
  },
  methods: {
    async handleFileAdd ({ $event, url }) {
      var files = $event.target.files || $event.dataTransfer.files
      if (!files.length) {
        return
      }

      this.$emit('error', {})
      this.$emit('uploading', '')

      const config = {
        url,
        onUploadProgress: progressEvent => {
          this.$emit('uploading', `업로드 중: ${Math.round((progressEvent.loaded * 100) / progressEvent.total)}%`)
        }
      }

      try {
        const { data } = await fileUpload(files[0], config)
        // this.files = []
        const file = {
          originalName: data.originalName,
          fileName: data.fileName,
          fileSize: data.fileSize,
          fileExt: data.fileExt,
          uuid: data.uuid
          // cancelToken
        }
        this.$emit('uploaded', file)
      } catch (ex) {
        // console.error(ex, ex.response)
        if (ex.response) {
          const { fieldId, errorMessage } = ex.response.data
          const error = { fieldId, errorMessage }
          this.$emit('error', error)
        }
        console.error(ex, ex.response)
      }
      this.$emit('uploading', ``)
    }
  }
}
